import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from 'react-bootstrap';

function PremiumGate({ message }) {
  return (
    <div className="mt-1">
      <Badge bg="warning" text="dark" className="me-1">Free Plan</Badge>
      <small className="text-muted">{message}</small>
      {' '}
      <small>
        <Link to="/settings?section=billing">Upgrade</Link>
      </small>
    </div>
  );
}

export default PremiumGate;
